import { render, staticRenderFns } from "./UploadProducts.vue?vue&type=template&id=4517c66b&scoped=true&"
import script from "./UploadProducts.vue?vue&type=script&lang=js&"
export * from "./UploadProducts.vue?vue&type=script&lang=js&"
import style0 from "./UploadProducts.vue?vue&type=style&index=0&id=4517c66b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4517c66b",
  null
  
)

export default component.exports